// @flow

import request from "./request"
import config from "../config.js"
import { getTokenBundle, setTokenBundle } from "../api/localTools"

export function safeParse (jsonStr) {
  try {
    return jsonStr ? JSON.parse(jsonStr) : {} // 解析 null 不会触发异常，因此还是需要做判断
  } catch(e) { // 主要为非法字符串
    return {}
  }
}

export function startRefresher () {
  setInterval(refreshToken, 1000 * 60 * 60)
}

export function refreshToken () {
  return request.post(`${config.backend}/auth/refresh`)
    .type("application/json")
    .send(getTokenBundle())
    .commonDispose()
    .then(res => {
      if (res.token) {
        setTokenBundle(JSON.stringify(res))
      }
    })
}

export function disposeFileSize (byteCount: number): string {
  let types = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB']
  let e = Math.floor(Math.log(byteCount)/Math.log(1024))

  return (byteCount/Math.pow(1024, Math.floor(e))).toFixed(2) + types[e]
}

export function disposeFilename(filename: string, visibleLength: number = 30) {
  let arr = filename.split(".")
  if (filename != null && arr[0].length > visibleLength) {
    const ellipsisFilename = filename.substring(0, visibleLength - 1) + "...." + arr[arr.length - 1]
    return {
      filename: ellipsisFilename,
      isEllipsis: true,
      end: arr.pop(),
      front: arr.join(".") + ".",
    }
  } else {
    return {
      filename: filename,
      isEllipsis: false,
      end: arr.pop(),
      front: arr.join(".") + ".",
    }
  }
}
/*
 * 分离尾部数字，没有的使用 0 补充
 */
export function splitStrNumber (str: string) {
  const number = getSuffixNumber(str)

  return {
    string: number ? str.slice(0, str.indexOf(number + "")) : str,
    number
  }
}

/*
 * 获取字符串尾部的数字值
 */
export function getSuffixNumber (str: string): number {
  const matched = str.match(/(\d+)$/)
  return matched ? parseInt(matched[1], 10) : 0
}

export function getRandomColor () {
  const r = Math.floor(Math.random() * 256)
  const g = Math.floor(Math.random() * 256)
  const b = Math.floor(Math.random() * 256)
  return `rgba(${r}, ${g}, ${b}, 0.5)`
}

export const debounce = (params = {}) => (target, name, descriptor) => {
  let timer = null
  const { delay = 300, immediate = false } = params

  // high order function
  if (!descriptor || (arguments.length === 1 && typeof target === 'function')) {
    return createDebounce(target)
  }

  function createDebounce (fn) {
    return function debounce () {
      if (immediate && !timer) {
        fn.apply(this, arguments)
      }
      if (timer) {
        clearTimeout(timer)
      }

      let argumentsCopy = arguments
      let that = this

      timer = setTimeout(function () {
        if (!immediate) {
          fn.apply(that, argumentsCopy)
        }
        timer = null
      }, delay)
    }
  }

  if(descriptor.value) {
    return {
      enumerable: false,
      configurable: true,
      writable: true,
      value: createDebounce(descriptor.value)
    }
  }

  if (descriptor.initializer) {
    return {
      enumerable: false,
      configurable: true,
      writable: true,
      initializer () {
        return createDebounce(descriptor.initializer.call(this))
      }
    }
  }

  return descriptor
}

/**
 * not pure function and will change obj self
 * @param obj
 */
export function beautifyObj (obj) {
  for(let key in obj) {
    if (obj[key] !== 0 && !obj[key]) {
      delete obj[key]
    }
  }
}

export function pureBeautifyObj (obj) {
  const res = {}
  for (let key in obj) {
    if (obj[key] === 0 || obj[key]) { // 0 is ok
      res[key] = obj[key]
    }
  }

  return res
}

export function getCurrentAppFromPath () {
  return (window.location.pathname.match(/\/(pgs|pgd|azf)/) || [null, null])[1]
}



// WEBPACK FOOTER //
// ./src/app/vendor/util.js